// extracted by mini-css-extract-plugin
export default {"antd":"common_antd__2EEbT"};